/*
 * Sidebar link to the Agents page.
 *
 * Separate from the catalog's own nav items on purpose: an agent is StackSchematic's
 * infrastructure, not an entity in the estate, and grouping it with Catalog or Catalog Graph
 * would imply otherwise.
 */
import { SidebarItem } from '@backstage/core-components';
import RadarIcon from '@material-ui/icons/TrackChanges';

import { AGENTS_PATH } from './index';

export function AgentsNavItem() {
  return <SidebarItem icon={RadarIcon} to={AGENTS_PATH} text="Agents" />;
}
